import { useState } from 'react';

export default function usePagainate() {
  const [resultsPerPage, setResultsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const resetPage = () => {
    setCurrentPage(1);
  };

  return {
    resultsPerPage,
    currentPage,
    nextPage,
    prevPage,
    resetPage,
    setResultsPerPage
  };
}
